import React, { useContext, useState, useEffect } from "react";
import { DataContext } from "../../contexts/DataContext";
import styled from "styled-components";
import Games from "../Games/Games";
import Live from "./Live";
import { useParams, Switch, Route } from "react-router-dom";
import { GraphicsContext } from "../../contexts/GraphicsContext";
import { UIContext, VIEW_CONSTS } from "../../contexts/UIContext";
import LeftSideBar from "../LeftSideBar/LeftSideBar";
import NavBar from "../TopBar/NavBar";
import Fruit from "./Fruit";

import Login from "../Login/Login";
import Config from "../Popup/Config";

import Stats from "./Stats";
import Stream from "./Stream";
import CustomTable from "./CustomTable";
import Table from "./Table";

const MainDiv = styled.div`
  display: flex;
  height: 100vh;
  width: calc(100vw - 44px);
`;
const MainDivStream = styled.div`
  display: flex;
  height: calc(100vh - 40px);
  width: 100vw;
`;
const LeftBar = styled.div`
  display: flex;
  min-width: 44px;
  box-shadow: 3px -1px 3px 0 rgb(0 0 0 / 42%);
  background-color: #202731;
`;
const Content = styled.div`
  display: flex;
  box-sizing: border-box;
  flex: 1;
  width: 100vw;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;
export default function Main() {
  const { view, setView, editPlayer, setEditPlayer } = useContext(UIContext);
  const { teams, fixtures, selectedGame, setSelectedGame, players } =
    useContext(DataContext);
  const { animateGraphic, graphicInPreview, animateOffGraphic, clearPVW } =
    useContext(GraphicsContext);
  const { setSelectedGameID } = useContext(DataContext);

  const [selectedPlayer, setSelectedPlayer] = useState();
  const [showConfig, setShowConfig] = useState(false);
  let { gameID } = useParams();

  useEffect(() => {
    if (players && selectedPlayer) {
      let p = players.find((p) => p.uuid === selectedPlayer.player);
      setSelectedPlayer({ ...p, player: p.uuid });
    }
  }, [players]);

  useEffect(() => {
    if (gameID) {
      setSelectedGameID(gameID);
      if (view === VIEW_CONSTS.matchSelect) {
        setView(VIEW_CONSTS.live);
      }
    } else {
      setView(VIEW_CONSTS.matchSelect);
      setSelectedGame(null);
    }
  }, [fixtures, gameID]);

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.keyCode === 119 || e.keyCode === 109) {
        if (graphicInPreview) {
          animateGraphic(graphicInPreview.name);
        }
        e.preventDefault();
      } else if (e.keyCode === 120 || e.keyCode === 106) {
        if (graphicInPreview) {
          animateOffGraphic(graphicInPreview.name);
        }
        e.preventDefault();
      } else if (e.keyCode === 81 && e.ctrlKey) {
        if (graphicInPreview) {
          clearPVW(graphicInPreview.name);
        }
      }
    }
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [graphicInPreview]);

  return (
    <div>
      <Content>
        <Switch>
          <Route path="/stream/:gameID/table">
            <Column>
              <NavBar />
              <MainDivStream>
                <LeftBar>
                  <LeftSideBar
                    view={VIEW_CONSTS.live}
                    setShowConfig={setShowConfig}
                    stream={true}
                  />
                </LeftBar>
                <Table
                  setSelectedPlayer={setSelectedPlayer}
                  selectedPlayer={selectedPlayer}
                  view={view}
                  setView={setView}
                />
                {showConfig && <Config title="Config" />}
              </MainDivStream>
            </Column>
          </Route>
          <Route path="/stream/:gameID/customtable">
            <Column>
              <NavBar />
              <MainDivStream>
                <LeftBar>
                  <LeftSideBar
                    view={VIEW_CONSTS.live}
                    setShowConfig={setShowConfig}
                    stream={true}
                  />
                </LeftBar>
                <CustomTable
                  setSelectedPlayer={setSelectedPlayer}
                  selectedPlayer={selectedPlayer}
                  view={view}
                  setView={setView}
                />
                {showConfig && <Config title="Config" />}
              </MainDivStream>
            </Column>
          </Route>
          <Route path="/stream/:gameID">
            <Column>
              <NavBar />
              <MainDivStream>
                <LeftBar>
                  <LeftSideBar
                    view={VIEW_CONSTS.live}
                    setShowConfig={setShowConfig}
                    stream={true}
                  />
                </LeftBar>
                <Stream
                  setSelectedPlayer={setSelectedPlayer}
                  selectedPlayer={selectedPlayer}
                  view={view}
                  setView={setView}
                />
                {showConfig && <Config title="Config" />}
              </MainDivStream>
            </Column>
          </Route>
          <Route path="/stream">
            <Column>
              <NavBar />

              <MainDivStream>
                <LeftBar>
                  <LeftSideBar view={VIEW_CONSTS.matchSelect} stream={true} />
                </LeftBar>
                <Games
                  fixtures={fixtures}
                  teams={teams}
                  onSelectGame={(game) => {
                    setSelectedGame(game);
                  }}
                />
              </MainDivStream>
            </Column>
          </Route>
          <Route path="/fruit/:gameID">
            <LeftBar>
              <LeftSideBar view={VIEW_CONSTS.live} isFruit={true} />
            </LeftBar>
            <Column>
              <NavBar />
              <MainDiv>
                <Fruit
                  setSelectedPlayer={setSelectedPlayer}
                  selectedPlayer={selectedPlayer}
                  view={view}
                  setView={setView}
                />
              </MainDiv>
            </Column>
          </Route>

          <Route path="/fruit">
            <Column>
              <NavBar />

              <MainDiv>
                <LeftBar>
                  <LeftSideBar view={VIEW_CONSTS.matchSelect} />
                </LeftBar>
                <Games
                  fixtures={fixtures}
                  teams={teams}
                  onSelectGame={(game) => {
                    setSelectedGame(game);
                  }}
                />
              </MainDiv>
            </Column>
          </Route>
          <Route path="/:gameID/table">
            <Column>
              <NavBar />

              <MainDiv>
                <LeftBar>
                  <LeftSideBar view={VIEW_CONSTS.live} isFruit={true} />
                </LeftBar>
                <Table
                  setSelectedPlayer={setSelectedPlayer}
                  selectedPlayer={selectedPlayer}
                  view={view}
                  setView={setView}
                />
                {showConfig && <Config title="Config" />}
              </MainDiv>
            </Column>
          </Route>
          <Route path="/:gameID">
            <LeftBar>
              <LeftSideBar
                view={VIEW_CONSTS.live}
                setShowConfig={setShowConfig}
              />
            </LeftBar>
            <Live
              setSelectedPlayer={setSelectedPlayer}
              selectedPlayer={selectedPlayer}
              view={view}
              setView={setView}
            />
            {showConfig && <Config title="Config" />}
          </Route>
          <Route path="/">
            <Column>
              <NavBar />

              <MainDiv>
                <LeftBar>
                  <LeftSideBar view={VIEW_CONSTS.matchSelect} isFruit={true} />
                </LeftBar>
                <Games
                  fixtures={fixtures}
                  teams={teams}
                  onSelectGame={(game) => {
                    setSelectedGame(game);
                  }}
                />
              </MainDiv>
            </Column>
          </Route>
          <Route path="/stats">
            <LeftBar>
              <LeftSideBar view={VIEW_CONSTS.matchSelect} isFruit={true} />
            </LeftBar>
            <Column>
              <NavBar />
              <MainDiv>
                <Stats view={view} setView={setView} />
              </MainDiv>
            </Column>
          </Route>
        </Switch>
      </Content>
    </div>
  );
}
